import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { createProjectUrl } from 'helpers/nexus'
import useHostname from 'hooks/useHostname'

import FormattedMessage from 'components/FormattedMessage'

const RedirectToNexus = ({ provider }) => {
  const hostname = useHostname()
  const currentAgency = useSelector((state) => state.headerData.currentAgency)

  useEffect(() => {
    window.location.href = createProjectUrl(provider?.id, hostname, currentAgency?.nexusDomain)
  }, [provider])

  return (
    <div>
      <FormattedMessage id="contactRequest.redirectingToNexus.message" />
    </div>
  )
}

RedirectToNexus.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
}

export default RedirectToNexus
